import Loadable from "app/components/Loadable";
import { lazy } from "react";
import { PERMISSIONS } from "app/utils/permissions";

const FarmCategoryList = Loadable(lazy(() => import("./FarmCategoryList")));
const FarmCategoryForm = Loadable(lazy(() => import("./FarmCategoryForm")));

const farmCategoryRoutes = [
  {
    path: "/FarmCategory/FarmCategoryList",
    element: <FarmCategoryList />,
    permission: PERMISSIONS.FarmCategories.Menu,
  },
  {
    path: "/FarmCategory/FarmCategoryForm",
    element: <FarmCategoryForm />,
  },
  {
    path: "/FarmCategory/FarmCategoryForm/:farmCategoryId",
    element: <FarmCategoryForm />,
  },
];

export default farmCategoryRoutes;
